module.exports = __webpack_public_path__ + "img/A58A0712_min.adbe4fbe.jpg";